import { analyzerDataStateInterface, DefaultCreateorEditresponse } from "actions/Analyzer/types";
import { defaultGetResponse } from "interfaces/ActionReducer/GetMethod/GetResponse";
import {
    updateCurrentSubZone,
    getLinksInPolygon,
    linksInPolygonsReceived,
    highlightPolygonLinks,
    highlightSegmentLinks,
    setPolygonFeatures,
    setSegmentFeatures,
    getAllProposedAnalysisZones,
    allProposedAnalysisZonesReceived,
    setSelectedZones,
    toggleAnalysisZonesActionPerformed,
    toggleFormValidated,
    confirmAnalysisZoneToggle,
    analysisZoneAndSubZonesCreated,
    createAnalysisZoneAndSubZones,
    editAnalysisZoneAndSubZones,
    getZoneComponents,
    proposedZoneId,
    zoneComponentsReceived,
    clearZoneComponents,
    updateZoneFilters,
    dataForAnalyzerFiltersReceived,
    setAnalyzerFilterParams,
    analysisZoneAndSubZonesEdited
} from "../actions";
import { createReducer } from "@reduxjs/toolkit";
import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

const initialState: analyzerDataStateInterface = {
    allProposedAnalysisZones: defaultGetResponse,
    currentSubZone: null,
    highlightedPolygonLinks: [],
    isAllProposedAnalysisZonesFetching: false,
    isFetchingPolygonLinks: true,
    polygonFeatures: {},
    segmentFeatures: {},
    proposedZoneId: 0,
    polygonLinks: [],
    selectedZoneIds: [],
    isFormValidated: false,
    confirmAnalysisZoneToggle: false,
    isAnalysisZoneAndSubZonesCreated: false,
    zoneComponents: {},
    isZoneComponentsReceived: false,
    zoneFilters: new Set(),
    isTableauParamsReceived: false,
    highlightedSegmentLinks: [],
    analysisZoneAndSubZonesCreated: DefaultCreateorEditresponse,
    isAnalysisZoneAndSubZonesEdited: false,
    analysisZoneAndSubZonesEdited: DefaultCreateorEditresponse,
    listViewFilterParams: {},
    listViewFiltersData: [],
    actionPerformed: false
};

const Analyzer = createReducer(initialState, (builder) => {
    builder
        .addCase(updateCurrentSubZone, (state, action) => {
            state.currentSubZone = action.payload.subZone;
        })
        .addCase(getLinksInPolygon, (state) => {
            state.isFetchingPolygonLinks = true;
        })
        .addCase(linksInPolygonsReceived, (state, action) => {
            state.isFetchingPolygonLinks = false;
            state.polygonLinks = action.payload.response;
        })
        .addCase(highlightPolygonLinks, (state, action) => {
            state.highlightedPolygonLinks = action.payload.links;
        })
        .addCase(highlightSegmentLinks, (state, action) => {
            state.highlightedSegmentLinks = action.payload.links;
        })
        .addCase(setPolygonFeatures, (state, action) => {
            state.polygonFeatures = action.payload.features;
        })
        .addCase(setSegmentFeatures, (state, action) => {
            state.segmentFeatures = action.payload.features;
        })
        .addCase(getAllProposedAnalysisZones, (state) => {
            state.isAllProposedAnalysisZonesFetching = true;
        })
        .addCase(allProposedAnalysisZonesReceived, (state, action) => {
            state.allProposedAnalysisZones = action.payload.data;
            state.isAllProposedAnalysisZonesFetching = false;
        })
        .addCase(setSelectedZones, (state, action) => {
            state.selectedZoneIds = action.payload.zoneIds;
        })
        .addCase(toggleAnalysisZonesActionPerformed, (state, action) => {
            state.actionPerformed = !action.payload.actionPerformed;
        })
        .addCase(toggleFormValidated, (state, action) => {
            state.isFormValidated = action.payload.validated;
        })
        .addCase(confirmAnalysisZoneToggle, (state, action) => {
            state.confirmAnalysisZoneToggle = action.payload.toggle;
        })
        .addCase(analysisZoneAndSubZonesCreated, (state, action) => {
            state.analysisZoneAndSubZonesCreated = action.payload.response;
            state.isAnalysisZoneAndSubZonesCreated = Boolean(action.payload.response.id);
        })
        .addCase(createAnalysisZoneAndSubZones, (state) => {
            state.isAnalysisZoneAndSubZonesCreated = false;
        })
        .addCase(editAnalysisZoneAndSubZones, (state) => {
            state.isAnalysisZoneAndSubZonesEdited = false;
        })
        .addCase(analysisZoneAndSubZonesEdited, (state, action) => {
            state.analysisZoneAndSubZonesEdited = action.payload.data;
            state.isAnalysisZoneAndSubZonesEdited = Boolean(action.payload.data.id);
        })
        .addCase(getZoneComponents, (state) => {
            state.isZoneComponentsReceived = false;
        })
        .addCase(proposedZoneId, (state, action) => {
            state.proposedZoneId = action.payload.id;
        })
        .addCase(zoneComponentsReceived, (state, action) => {
            state.isZoneComponentsReceived = true;
            state.zoneComponents = action.payload.response;
        })
        .addCase(clearZoneComponents, (state) => {
            state.zoneComponents = {};
            state.segmentFeatures = {};
            state.polygonFeatures = {};
            state.highlightedPolygonLinks = [];
            state.highlightedSegmentLinks = [];
            state.proposedZoneId = 0;
            state.selectedZoneIds = [];
            state.zoneFilters = new Set();
        })
        .addCase(updateZoneFilters, (state, action) => {
            state.zoneFilters = action.payload.zones;
        })
        .addCase(dataForAnalyzerFiltersReceived, (state, action) => {
            state.listViewFiltersData = action.payload.data;
        })
        .addCase(setAnalyzerFilterParams, (state, action) => {
            state.listViewFilterParams = action.payload.params;
        })
        .addCase(resetStateRTK, () => initialState)
        .addDefaultCase((state) => state);
});

export default Analyzer;
